// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.audio-control {
  display: inline-block;
  margin-top: 8px;
  margin-left: 10px;
  padding: 4px 8px;
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  color: #333;
}

.audio-control.playing {
  background-color: #e0e0e0;
  color: #007bff;
}

.clarification-message.ai {
  position: relative;
}

.clarification-message.ai .audio-control {
  position: absolute;
  top: 8px;
  right: 8px;
  opacity: 0.7;
}

.clarification-message.ai:hover .audio-control {
  opacity: 1;
}

/* Clarification Button and Popup Styling */
.clarification-button {
  padding: 8px 12px;
  background-color: var(--info);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s ease;
  margin-right: 10px;
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 0.9rem;
}

.clarification-button:hover {
  background-color: var(--info);
  filter: brightness(90%);
  transform: translateY(-1px);
}

.clarification-button svg {
  width: 16px;
  height: 16px;
}

.clarification-popup {
  position: fixed;
  top: 0;
  right: 0;
  width: 400px;
  height: 100vh;
  background-color: var(--bg-secondary);
  box-shadow: -5px 0 15px var(--shadow-color);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  transform: translateX(100%);
  transition: transform 0.3s ease-in-out;
  border-left: 1px solid var(--border-color);
}

.clarification-popup.active {
  transform: translateX(0);
}

.clarification-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid var(--border-color);
  background-color: var(--bg-tertiary);
}

.clarification-header h3 {
  margin: 0;
  color: var(--accent-primary);
}

.close-clarification {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: var(--text-secondary);
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s ease;
}

.close-clarification:hover {
  color: var(--accent-primary);
}

.clarification-context {
  padding: 15px 20px;
  background-color: var(--bg-tertiary);
  border-bottom: 1px solid var(--border-color);
  margin-bottom: 10px;
}

.clarification-context h4 {
  margin-top: 0;
  color: var(--text-secondary);
  font-size: 0.9rem;
  margin-bottom: 8px;
}

.clarification-context p {
  margin: 0;
  font-size: 0.85rem;
  color: var(--text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.clarification-chat {
  flex: 1;
  padding: 15px 20px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.clarification-input-container {
  padding: 15px 20px;
  border-top: 1px solid var(--border-color);
  display: flex;
  gap: 10px;
}

.clarification-input {
  flex: 1;
  padding: 12px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  font-family: inherit;
  background-color: var(--bg-primary);
  color: var(--text-primary);
  resize: none;
}

.clarification-input:focus {
  border-color: var(--accent-primary);
  outline: none;
}

.send-clarification {
  padding: 0;
  width: 40px;
  background-color: var(--accent-primary);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.send-clarification:hover:not(:disabled) {
  background-color: var(--button-hover);
}

.send-clarification:disabled {
  background-color: var(--text-secondary);
  cursor: not-allowed;
  opacity: 0.7;
}

.clarification-message {
  padding: 10px 15px;
  border-radius: 18px;
  max-width: 85%;
  animation: fadeIn 0.3s ease-in-out;
}

.clarification-message.user {
  align-self: flex-end;
  background-color: var(--chat-user);
  color: white;
  border-bottom-right-radius: 4px;
}

.clarification-message.ai {
  align-self: flex-start;
  background-color: var(--chat-ai);
  color: var(--ai-text);
  border-bottom-left-radius: 4px;
}

/* Mobile responsiveness for the clarification popup */
@media (max-width: 768px) {
  .clarification-popup {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/exams/clarification.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA,2CAA2C;AAC3C;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,2CAA2C;EAC3C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,sCAAsC;EACtC,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;EAC5C,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,4BAA4B;EAC5B,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,SAAS;AACX;;AAEA;EACE,OAAO;EACP,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,oBAAoB;EACpB,mCAAmC;EACnC,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,aAAa;AACf;;AAEA;EACE,UAAU;EACV,WAAW;EACX,uCAAuC;EACvC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;EAClC,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA,sDAAsD;AACtD;EACE;IACE,WAAW;EACb;AACF","sourcesContent":[".audio-control {\n  display: inline-block;\n  margin-top: 8px;\n  margin-left: 10px;\n  padding: 4px 8px;\n  background-color: #f0f0f0;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  color: #333;\n}\n\n.audio-control.playing {\n  background-color: #e0e0e0;\n  color: #007bff;\n}\n\n.clarification-message.ai {\n  position: relative;\n}\n\n.clarification-message.ai .audio-control {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  opacity: 0.7;\n}\n\n.clarification-message.ai:hover .audio-control {\n  opacity: 1;\n}\n\n/* Clarification Button and Popup Styling */\n.clarification-button {\n  padding: 8px 12px;\n  background-color: var(--info);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.2s ease;\n  margin-right: 10px;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 0.9rem;\n}\n\n.clarification-button:hover {\n  background-color: var(--info);\n  filter: brightness(90%);\n  transform: translateY(-1px);\n}\n\n.clarification-button svg {\n  width: 16px;\n  height: 16px;\n}\n\n.clarification-popup {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 400px;\n  height: 100vh;\n  background-color: var(--bg-secondary);\n  box-shadow: -5px 0 15px var(--shadow-color);\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  transform: translateX(100%);\n  transition: transform 0.3s ease-in-out;\n  border-left: 1px solid var(--border-color);\n}\n\n.clarification-popup.active {\n  transform: translateX(0);\n}\n\n.clarification-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 20px;\n  border-bottom: 1px solid var(--border-color);\n  background-color: var(--bg-tertiary);\n}\n\n.clarification-header h3 {\n  margin: 0;\n  color: var(--accent-primary);\n}\n\n.close-clarification {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  color: var(--text-secondary);\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.2s ease;\n}\n\n.close-clarification:hover {\n  color: var(--accent-primary);\n}\n\n.clarification-context {\n  padding: 15px 20px;\n  background-color: var(--bg-tertiary);\n  border-bottom: 1px solid var(--border-color);\n  margin-bottom: 10px;\n}\n\n.clarification-context h4 {\n  margin-top: 0;\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n  margin-bottom: 8px;\n}\n\n.clarification-context p {\n  margin: 0;\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.clarification-chat {\n  flex: 1;\n  padding: 15px 20px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.clarification-input-container {\n  padding: 15px 20px;\n  border-top: 1px solid var(--border-color);\n  display: flex;\n  gap: 10px;\n}\n\n.clarification-input {\n  flex: 1;\n  padding: 12px;\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  font-family: inherit;\n  background-color: var(--bg-primary);\n  color: var(--text-primary);\n  resize: none;\n}\n\n.clarification-input:focus {\n  border-color: var(--accent-primary);\n  outline: none;\n}\n\n.send-clarification {\n  padding: 0;\n  width: 40px;\n  background-color: var(--accent-primary);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.send-clarification:hover:not(:disabled) {\n  background-color: var(--button-hover);\n}\n\n.send-clarification:disabled {\n  background-color: var(--text-secondary);\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.clarification-message {\n  padding: 10px 15px;\n  border-radius: 18px;\n  max-width: 85%;\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n.clarification-message.user {\n  align-self: flex-end;\n  background-color: var(--chat-user);\n  color: white;\n  border-bottom-right-radius: 4px;\n}\n\n.clarification-message.ai {\n  align-self: flex-start;\n  background-color: var(--chat-ai);\n  color: var(--ai-text);\n  border-bottom-left-radius: 4px;\n}\n\n/* Mobile responsiveness for the clarification popup */\n@media (max-width: 768px) {\n  .clarification-popup {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
